import { AxiosError } from "axios";

/** The byte limit a `FILE_TOO_LARGE` upload-url rejection reports, else null. */
export function uploadSizeLimitFromError(error: unknown): number | null {
  if (!(error instanceof AxiosError)) {
    return null;
  }
  const data: unknown = error.response?.data;
  if (typeof data !== "object" || data === null) {
    return null;
  }
  const { code, maxBytes } = data as { code?: unknown; maxBytes?: unknown };
  if (code !== "FILE_TOO_LARGE" || typeof maxBytes !== "number") {
    return null;
  }
  return maxBytes;
}

export function bytesToWholeMegabytes(bytes: number): number {
  return Math.floor(bytes / (1024 * 1024));
}
